var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalHeaderClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8769 0C16.8896 0 21.7636 4.9247 21.7636 11C21.7636 17.0753 16.8896 22 10.8769 22C4.8642 22 -0.00976562 17.0753 -0.00976562 11C-0.00976562 4.9247 4.8642 0 10.8769 0ZM10.8769 2.2C8.56705 2.2 6.3518 3.12714 4.71848 4.77746C3.08516 6.42778 2.16757 8.66609 2.16757 11C2.16757 13.3339 3.08516 15.5722 4.71848 17.2225C6.3518 18.8729 8.56705 19.8 10.8769 19.8C13.1868 19.8 15.402 18.8729 17.0354 17.2225C18.6687 15.5722 19.5863 13.3339 19.5863 11C19.5863 8.66609 18.6687 6.42778 17.0354 4.77746C15.402 3.12714 13.1868 2.2 10.8769 2.2ZM10.8769 4.4C11.1436 4.40004 11.4009 4.49895 11.6002 4.67799C11.7995 4.85702 11.9268 5.10372 11.958 5.3713L11.9656 5.5V10.5446L14.9126 13.5223C15.1079 13.7203 15.2212 13.9859 15.2297 14.2652C15.2381 14.5446 15.141 14.8167 14.9581 15.0263C14.7751 15.2359 14.5201 15.3673 14.2447 15.3938C13.9694 15.4203 13.6944 15.34 13.4756 15.169L13.3732 15.0777L10.1072 11.7777C9.93803 11.6066 9.82936 11.3839 9.79805 11.1441L9.78825 11V5.5C9.78825 5.20826 9.90295 4.92847 10.1071 4.72218C10.3113 4.51589 10.5882 4.4 10.8769 4.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalHeaderClockIcon);
export default __webpack_public_path__ + "static/media/terminalHeaderClockIcon.85f97b22080b15b63dd7fdc1d6bfbee8.svg";
export { ForwardRef as ReactComponent };